// src/components/CardSection.js
import React from "react";
import "../App.css";
import "./CardSection.css";
import CarouselSection from "./CarouselSection";
import { Button } from "./Button";
import { Link } from "react-router-dom";

function CardSection() {
  const slides = [
    {
      image: "/images/1car.png",
      title: "Immersive 360° Tours",
      text: "Showcase your property with virtual walkthroughs that convert views into visits.",
    },
    {
      image: "/images/3car.png",
      title: "Cinematic Drone Footage",
      text: "Highlight unique perspectives that capture attention and build trust.",
    },
    {
      image: "/images/2car.png",
      title: "High-Impact Video",
      text: "Dynamic video storytelling turns your property into an unforgettable experience. Professional editing emphasizes key selling points and boosts engagement online.",
    },
    {
      image: "/images/4car.png",
      title: "Professional Photography",
      text: "Crisp, detail-rich photos… perfect for MLS, Airbnb, and social.",
    },
  ];

  return (
    <section className="card-section">
      {/* LEFT: text */}
      <div className="card-content">
        <h1>Immersive Media for Real Estate Success</h1>

        <p>
          We don’t just capture properties, we create digital
          experiences that <strong>sell and book faster</strong>.
        </p>
        <p>
          Our 360° virtual tours, cinematic drone footage, and high-impact
          photography give potential buyers and guests the ability to explore a
          space as if they were already there. This level of transparency and
          immersion builds trust, reduces hesitation, and turns views into
          visits, and visits into sales.
        </p>
        <p>
          For real estate developers and Airbnb hosts, our services mean more
          than beautiful visuals. They mean{" "}
          <strong>
            more qualified leads, more bookings, and stronger returns
          </strong>
          .
        </p>
        <p>
          With Fenix Media, you get more than content. You get a partner
          dedicated to{" "}
          <strong>showcasing your project’s value and driving results</strong>.
        </p>
        <Link className="btn-contact-us" to="/contact">
          <Button
            className="btn-mobile"
            buttonStyle="fm-btn--outline"
            buttonSize="fm-btn--large"
          >
            Contact Us
          </Button>
        </Link>
      </div>
      {/* RIGHT: carousel */}
      <div className="card-carousel">
        <CarouselSection slides={slides} interval={4000} />
      </div>
    </section>
  );
}

export default CardSection;
